import React from "react";

function Events() {
  return (
    <div className="p-3" style={{ height: "85vh" }}>
      עדיין לא נוספו אירועים
    </div>
  );
}

export default Events;
